import { Box, Switch, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { colors } from '../../theme/colors';

interface CalendarSectionProps {
  calendar: boolean;
  calendarSharing: boolean;
  disabled: boolean;
  onCalendarChange: (checked: boolean) => void;
  onCalendarSharingChange: (checked: boolean) => void;
}

const CalendarSection: FC<CalendarSectionProps> = ({
  calendar,
  calendarSharing,
  disabled,
  onCalendarChange,
  onCalendarSharingChange,
}) => {
  const { t } = useTranslation();

  return (
    <Box gap={5} sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
      <Box
        maxWidth={180}
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          color="primary"
          sx={{ fontSize: '13px', textTransform: 'uppercase' }}
          variant="text-xs-bold-caps"
        >
          {t('calendar-visibility')}
        </Typography>
        <Switch
          checked={calendar}
          disabled={disabled}
          onChange={(e) => onCalendarChange(e.target.checked)}
        />
      </Box>
      <Box
        gap={3}
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Box
          maxWidth={180}
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            color="primary"
            sx={{ fontSize: '13px', textTransform: 'uppercase' }}
            variant="text-xs-bold-caps"
          >
            {t('calendar-sharing')}
          </Typography>
          <Switch
            checked={calendarSharing}
            disabled={disabled || !calendar}
            onChange={(e) => onCalendarSharingChange(e.target.checked)}
          />
        </Box>
        {calendarSharing && (
          <Typography color={colors['gray-450']} variant="text-xxs">
            {t('calendar-sharing-warning')}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CalendarSection;
